import * as Yup from "yup";

/**
 * Validates the product form values based on the defined schema.
 *
 * @param {object} values - The values to be validated.
 * @param {number} values.ogr - The weighting OGR, required.
 * @param {number} values.customer_price - The customer price, required.
 * @param {string} values.status - The status, required.
 * @param {string} values.product_type - The product type, required.
 * @param {string} [values.product_description] - The product description, optional.
 * @param {string} values.product - The product name, required.
 * @returns {Promise<object>} A promise that resolves with the validated values or rejects with an error message.
 */
export default function productFormValidation(values) {
  return new Promise((resolve, reject) => {
    const schema = Yup.object().shape({
      com_ogr_percentage_receivable: Yup.number()
        .typeError("OGR % - Must be a number")
        .min(0, "OGR % - Must be a positive number")
        .required("OGR % - Required field"),

      com_once_off_receivable_vat_excl: Yup.number()
        .typeError("Commission Receivable - Must be a number")
        .positive("Commission Receivable - Must be a positive number")
        .required("Commission Receivable - Required field"),

      customer_price_vat_excl: Yup.number()
        .typeError("Customer Price - Must be a number")
        .positive("Customer Price - Must be a positive number")
        .required("Customer Price - Required field"),

      display_name: Yup.string().required("Product - Required field"),

      product_description: Yup.string()
        .nullable() // Allows null
        .notRequired(), // Makes it optional

      refs_product_status_id: Yup.number()
        .typeError("Please select a Product Status")
        .integer("Please select a Product Status")
        .required("Please select a Product Status"),

      refs_product_type_id: Yup.number()
        .typeError("Please select a Product Type")
        .integer("Please select a Product Type")
        .required("Please select a Product Type"),

      revenue_points: Yup.number()
        .typeError("Revenue Points - Must be a number")
        .min(0, "Revenue Points - Must be a positive number")
        .integer("Revenue Points - Must be an integer")
        .required("Revenue Points - Required field"),
    });

    schema
      .validate(values)
      .then(result => {
        resolve(result);
      })
      .catch(err => {
        reject(err.message);
      });
  });
}
